import React from "react";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Button, Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

type Props = React.ComponentProps<typeof Button>;

const useStyles = makeStyles()((theme: Theme) => ({
  goalButton: {
    "& .MuiButton-startIcon": {
      margin: "0px",
    },
    border: "2px solid #D4DBE5",
    "&:hover": {
      border: "2px solid #D4DBE5",
    },
    width: "28px",
    height: "28px",
    minWidth: "28px",
    borderRadius: "100%",
    marginLeft: "12px",
    color: colors.grey,
  },
}));

const DeleteIconButton: React.FC<Props> = (props) => {
  const { classes } = useStyles();
  return (
    <Button
      {...props}
      size="small"
      variant="outlined"
      startIcon={<CloseRoundedIcon fontSize="small" />}
      className={classes.goalButton}
    ></Button>
  );
};

export default DeleteIconButton;
